import { FC } from 'react'
import styles from './ComponentBodySessionBrowser.module.scss'

type ChangeHandler = (value: string) => void

type TheatreFilterArgs = {
    value: string | null,
    onChange: ChangeHandler,
    theatres: readonly string[],
}

export const TheatreFilters: FC<TheatreFilterArgs> =
    ({
        value,
        onChange,
        theatres
    }) =>
        <span data-number={theatres.length + 1} className={styles.Theatres}>
            <button key="all" data-active={value===null} onClick={() => onChange('all')}>
                All Theatres
            </button>
            {
                theatres
                    .map( theatre =>
                        theatre === null || theatre === undefined ? <></> :
                            <button key={theatre} data-active={value===theatre}
                                data-theatre={theatre} onClick={() => onChange(theatre)}>
                                    {theatre}
                            </button>
                    )
            }
        </span>
